import { gql } from '@apollo/client';

const AI_REFERENCE_QUESTION_FIELDS = `
  id
  label
  prompt
  fieldKey
  sortOrder
  isActive
`;

export const AI_REFERENCE_QUESTION_TEMPLATES = gql`
  query AiReferenceQuestionTemplates {
    aiReferenceQuestionTemplates {
      ${AI_REFERENCE_QUESTION_FIELDS}
    }
  }
`;

export const ADD_AI_REFERENCE_QUESTION = gql`
  mutation AddAiReferenceQuestion(
    $label: String!
    $prompt: String!
    $fieldKey: AiReferenceFieldKeyEnum
    $isActive: Boolean
  ) {
    addAiReferenceQuestion(label: $label, prompt: $prompt, fieldKey: $fieldKey, isActive: $isActive) {
      ${AI_REFERENCE_QUESTION_FIELDS}
    }
  }
`;

export const UPDATE_AI_REFERENCE_QUESTION = gql`
  mutation UpdateAiReferenceQuestion(
    $id: String!
    $label: String
    $prompt: String
    $fieldKey: AiReferenceFieldKeyEnum
    $isActive: Boolean
  ) {
    updateAiReferenceQuestion(id: $id, label: $label, prompt: $prompt, fieldKey: $fieldKey, isActive: $isActive) {
      ${AI_REFERENCE_QUESTION_FIELDS}
    }
  }
`;

export const DELETE_AI_REFERENCE_QUESTION = gql`
  mutation DeleteAiReferenceQuestion($id: String!) {
    deleteAiReferenceQuestion(id: $id)
  }
`;

export const REORDER_AI_REFERENCE_QUESTIONS = gql`
  mutation ReorderAiReferenceQuestions($ids: [String!]!) {
    reorderAiReferenceQuestions(ids: $ids) {
      ${AI_REFERENCE_QUESTION_FIELDS}
    }
  }
`;
